/**
 * Message Type that can be sent to a ChargePoint
 */
export enum ChargingProfilePurposeType {
    CHARGE_POINT_MAX_PROFILE = 'CHARGE_POINT_MAX_PROFILE',
    TX_DEFAULT_PROFILE = 'TX_DEFAULT_PROFILE',
    TX_PROFILE = 'TX_PROFILE'
}
